<template>
  <div class>
    <div class="gPageBorder">
      <el-row :gutter="10" class="gTopMg" style="margin-bottom: 20px;padding:0 20px 0 20px;">
        <el-col :span="4">
          <div class>
            <MechanismSelector style="width:100%;" :data="mechanismData"></MechanismSelector>            
          </div>
        </el-col>
        <el-col :span="4" style>
          <el-input
            :placeholder="$t('lin_global.label_no')"
            icon="search"
            v-model="tno"
            :on-icon-click="handleIconClick"
            @keyup.enter.native="focusEvent(handleIconClick)"
          ></el-input>
        </el-col>
      </el-row>

      <el-table
        v-loading="loading"
        :element-loading-text="$t('lin_global.loading')"
        :data="tableData"
        id="tableData"
        @row-click='cellClick'
        border
        class="tbPoint"
        style="width:100%"
      >

        <el-table-column width="110" prop="id" label="ID"></el-table-column>
        <el-table-column width="150" prop="accountNo" :label="$t('app_cardno')"></el-table-column>  
        <el-table-column
          prop="traceId"
          width="150"
          :label="$t('app_trdno')"
          sshow-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          width="150"
          prop="batchId"
          :label="$t('app_batcno')"
          sshow-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column width="110" prop="amout" :label="$t('app_amout')"></el-table-column>
        <el-table-column width="150" prop="merchId" :label="$t('app_mechno')"></el-table-column>                
        <el-table-column
          width="150"
          prop="terminalNo"
          :label="$t('lin_global.label_no')"
          sshow-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column width="175" prop="requesTime" :label="$t('app_trdtime')"></el-table-column>
        <el-table-column width="175" prop="requestDate" :label="$t('app_trddate')"></el-table-column>
        <el-table-column width="150" prop="hostagentserialNo" :label="$t('app_trdcore')"></el-table-column>
        <el-table-column width="155" prop="referenceNo" :label="$t('app_expno')"></el-table-column>
        <el-table-column width="150" prop="authRc" :label="$t('app_license')"></el-table-column>
        <el-table-column width="150" prop="transType" :label="$t('app_trdtype')"></el-table-column>
        <el-table-column width="175" prop="recordTime" :label="$t('app_rectime')"></el-table-column>
        <el-table-column width="200" prop="faceUrl" :label="$t('app_fpaddrs')"></el-table-column>

        <!-- <el-table-column
          prop="status"
          :label="$t('lin_global.status')"
          :formatter="formatStatus"
          :show-overflow-tooltip="true"
          width="150"
        ></el-table-column> -->

        <!-- <el-table-column :label="$t('lin_global.ope')" width="180">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              v-if="scope.row.status == 2"
              effect="dark"
              :content="$t('lin_global.download')"
              placement="top"
            >
              <a style="color: #4db3ff" :href="downUrl(scope.row.logUrl)">
                <i class="fa fa-cloud-download" style></i>
              </a>
            </el-tooltip>

            <el-tooltip
              class="item"
              v-if="scope.row.status == 3"
              effect="dark"
              :content="$t('app_reupload')"
              placement="top"
            >
              <el-button type="text" @click="terlogOperate('2', scope.row)">
                <i class="fa fa-refresh" style></i>
              </el-button>
            </el-tooltip>
&nbsp;
            <el-tooltip
              class="item"
              v-if="scope.row.status == 2 || scope.row.status == 3"
              effect="dark"
              :content="$t('lin_btn.delete')"
              placement="top"
            >
              <el-button type="text" @click="submitRow(scope.row)">
                <i class="fa fa-trash-o" style="color:#FF4949"></i>
              </el-button>
            </el-tooltip>
            <el-button
              type="text"
              v-if="scope.row.status == 0"
              @click="terlogOperate('2', scope.row)"
            >
              <i class="fa fa-stop" style="color:#FF4949"></i>
            </el-button>           
          </template>
        </el-table-column> -->
      </el-table>
      <div v-if="total > 0" class="gPgDiv" id="pagination" style>
        <el-pagination
          class="gPg"
          style="float:right;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="$gRows"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import MechanismSelector from "@/components/global/mechanism_selector.vue";
import { baseurl, focusEvent, url, urlAssets } from "../../api/url";
export default {
  computed: {},
  components: {
    MechanismSelector
  },
  name: "log",
  data() {
    var that = this;
    return {
      baseUrl: urlAssets.prefix,
      focusEvent: focusEvent,
      areaList1: [],
      value1: "",
      input1: "",
      mech: "",
      econfig: {},
      mechanismData: {
        callback(value) {
          that.mech = value;
          that.search()          
        }
      },
      tno: '',
      loading: false,
      page: 1,
      total: 0,
      tableData: [],
      pip: "szzt",
      pcode: "szzt"
    };
  },
  created: function() {
    this.getList();
    this.getChannel();
  },
  destroyed() {
    clearInterval(window.logTm);
  },
  methods: {
    cellClick (row,ev,col) {
      this.$setWObj('trade', row)
      this.$router.push({path: '/trade/detail'})
    },
    showEQ() {
      var _this = this;
      this.econfig = {
        close: () => {
          // _this.econfig = ''
          _this.getList();
        }
      };
    },
    // upadteData() {
    //   var isUpdate = false;
    //   this.tableData.forEach(vl => {
    //     if (vl.status == 0 || vl.status == 1) {
    //       isUpdate = true;
    //       return;
    //     }
    //   });      
    // },
    terlogOperate(type, row) {
      var logId = type == "2" ? row.id : "";
      this.loading = true;
      this.$operateTerLog(
        type,
        logId,
        row.terminalNo,
        res => {
          this.loading = false;
          if (res.status === 200) {
            this.$message.success(res.message);
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        },
        error => {
          this.loading = false;
          this.$message.error(res.message);
        }
      );
    },
    downUrl(tail) {
      // return this.pip + tail
      return this.$host + tail;
    },
    getChannel() {
      // this.$getChannelList(this.pcode, this.pip, 999, 1, '', (res) => {
      // 	if (res.status === 200) {
      //   		this.areaList1 = res.data;
      // 	} else {
      // 		this.$message.error(res.message)
      // 	}
      // }, () => {
      // 	this.$message.error(this.$t('app_rqsError'))
      // })
    },
    getList() {      
      // this.loading = 1
      var tNo = this.tno?this.tno:''
      var mech = this.mech?this.mech:''
      this.$tradeList(this.page, this.$gRow, tNo, mech, res => {
          this.loading = 0;
          if (res.status === 200) {
            this.tableData = res.data;
            this.total = res.total;            
          } else {
            this.$message.error(res.message);
          }
        },
        err => {
          this.$message.error(this.$t("app_rqsError"));
          this.loading = 0;
        }
      );
    },
    catchLog() {},
    submitRow: function(row) {
      this.$confirm(this.$t("app_tipAppEdit"), this.$t("lin_btn.tips"), {
        confirmButtonText: this.$t("lin_btn.confirm"),
        cancelButtonText: this.$t("lin_btn.cancel"),
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.$delTerLog(
            row.id,
            res => {
              this.loading = false;
              if (res.status === 200) {
                this.$message.success(res.message);
                this.getList();
              } else {
                this.$message.error(res.message);
              }
            },
            err => {
              this.$message.error(this.$t("app_rqsError"));
              this.loading = false;
            }
          );
        })
        .catch(() => {});
    },    
    reset() {},
    statusChange() {
      this.getList();
    },
    handleIconClick: function() {
      this.getList();
    },
    formatStatus: function(row, column) {
      // return row.status == 0?this.$t('lin_global.ddsc'):row.status == 1?this.$t('lin_global.scz'):row.status == 2?this.$t('lin_global.sccg'):row.status == 3?this.$t('lin_global.scsb'):'';
      var data = {
        "0": this.$t("app_catching"),
        "1": this.$t("app_ulding"),
        "2": this.$t("app_ulyet"),
        "3": this.$t("lin_global.scsb")
      };
      return data[row.status];
    },
    search: function() {
      this.page = 1
      this.getList()      
    },

    handleSizeChange: function(val) {
      this.$gRow = val;
    },
    handleCurrentChange: function(val) {
      this.page = val;
      this.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// trList.vue?454fed18